export default __webpack_public_path__ + "static/tools-f48cf12cbae971ce225900c1911f5f5d.png";